 
import {YearMonthMap} from './SatIndexQueryParam'
Date.prototype.getWeek = function () {
    var onejan = new Date(this.getFullYear(), 0, 1);
    return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
};
export const season = ['Summer','Kharif','Rabi','Annual','Semi_perenial','Perennial']

 export function mapLocationData(data){
    let _locData = {
        state:'',
        district:'',
        sub_district:'',
        village: '',
        pincode: '',
        survey_no:'',
        area:'',
        driving_distance:''
    }
    const _state_val =  data.map(item => item.state_name)
                        .filter((value, index, self) => self.indexOf(value) === index)
    const state_val = _state_val.join(",")
    const _district_val = data.map((item) => item.district_name)
                .filter((value, index, self) => self.indexOf(value) === index) 
        const district_val = _district_val.join(",")

    const _pincode_val = data.map((item) => item.pincode)
    .filter((value, index, self) => self.indexOf(value) === index) 
    const pincode_val = _pincode_val.join(",")

    const _subdistrict_val = data.map((item) => item.subdistrict_name)
                .filter((value, index, self) => self.indexOf(value) === index)  
    const subdistrict_val = _subdistrict_val.join(",")
    const _village_val = data.map((item) => item.village_name)
                .filter((value, index, self) => self.indexOf(value) === index)  
    const village_val = _village_val.join(",")
    const _survey_val = data.map((item) => item.survey_no)
                .filter((value, index, self) => self.indexOf(value) === index)  
    const survey_val = _survey_val.join(",")

    const _area_val = data.map((item) => item.area)
        .filter((value, index, self) => self.indexOf(value) === index)  
    const area_val = _area_val.join(",")

    const dist_val = data.map((item) => item.driving_distance)
    _locData.state = state_val
    _locData.district = district_val
    _locData.sub_district = subdistrict_val
    _locData.pincode = pincode_val
    _locData.village = village_val
    _locData.survey_no = survey_val
    _locData.area = area_val
    _locData.driving_distance = dist_val
    return _locData
 }

export function mapSeasonCover(croptable){
    let season_cover = [
        {season:'Summer', crop: false},
        {season:'Kharif', crop: false},
        {season:'Rabi', crop: false},
        {season:'Annual', crop: false},
        {season:'Semi_perenial', crop: false},
        {season:'Perennial', crop: false}
        ]
    let seasonset = croptable.map((item) => item.crop_season)
    .filter((value, index, self) => self.indexOf(value) === index)

    // console.log(seasonset)
    for (const obj of season_cover)
   { 
    if (seasonset.includes('summer') && obj.season === 'Summer') {
        obj.crop = true;
        break;
        }
    if (seasonset.includes('kharif') && obj.season === 'Kharif') {
         obj.crop = true;
    }
    if (seasonset.includes('rabi') && obj.season === 'Rabi') {
        obj.crop = true;
        }
    if (seasonset.includes('annual') && obj.season === 'Annual') {
        obj.crop = true;
    }
    if (seasonset.includes('semi_perennial') && obj.season === 'Semi_perenial') {
        obj.crop = true;
    }
    if (seasonset.includes('perennial') && obj.season === 'Perennial') {
        obj.crop = true;
    }
    }       
    return season_cover
}

export function storeIndexTsHist(data){
    let data_ts=[]
    let data_hist=[]
    
         // const _data_ts = response.data.C0
         data.forEach((item)=> {
            let date = new Date(item.date)
            let weeknum = date.getWeek()
            let month = date.getMonth()+1
            let year = date.getFullYear()
            data_ts.push({
                 "date":item.date,
                 "year": year,
                 "month": month,
                 "weeknum": weeknum,
                 "max":item.basicStats.max,
                 "min":item.basicStats.min,
                 "mean":item.basicStats.mean,
                 "stdev":item.basicStats.stDev
               })})
        data.forEach((item)=> {
            let date = new Date(item.date)
            let weeknum = date.getWeek()
            let month = date.getMonth()+1
            let year = date.getFullYear()
            data_hist.push({
                "date":item.date,
                "year": year,
                "month":month,
                "weeknum":weeknum,
                "hist":item.histogram.bins
            })})
 return ({data_ts, data_hist})
}


const year_month = YearMonthMap()

export function MonthlyMappedIndexNdvi_S2_SAR(S2, SAR){
  let mapped_Data  = []
  let filtered_S2
  let filtered_SAR
  if (S2!==undefined && SAR !==undefined && S2.length>0 && 
    SAR.length >0 )
  {
  for (let i = 0; i < year_month.length; i++){ 
    let filtered_S2_val  =[]
    let filtered_SAR_val =[]
    let max_S2_VAL
    let max_SAR_VAL
    let index_val
    let fiters = {
        year:year_month[i][0],
        month: year_month[i][1]
        }
    // console.log(fiters)
    filtered_S2 = S2.filter(function(item) {
        for (var key in fiters) {
            if (item[key] === undefined || item[key] != fiters[key])
            return false;
        }
        return true;
        });
    filtered_S2.forEach((item)=> {
        if(isFinite(item.mean))
        {filtered_S2_val.push(item.mean)}
        else{
            filtered_S2_val.push(0)
        }
    })
    max_S2_VAL = Math.max.apply(null, filtered_S2_val) 
    filtered_SAR = SAR.filter(function(item) {
        for (var key in fiters) {
            if (item[key] === undefined || item[key] != fiters[key])
            return false;
        }
        return true;
        });
    filtered_SAR.forEach((item)=> {
        if(isFinite(item.mean))
        {filtered_SAR_val.push(item.mean)}
        else{
            filtered_SAR_val.push(0)
        }
    })
    if( filtered_SAR_val)
    max_SAR_VAL =  Math.max.apply(null, filtered_SAR_val)
    if( isFinite(max_S2_VAL)===true ){
        index_val = max_S2_VAL
    }
    else{
        index_val=max_SAR_VAL
    }
    let _series = {
        year: year_month[i][0],
        month:year_month[i][1],
        vegetationIndexS2: max_S2_VAL,
        vegetationIndexSAR: max_SAR_VAL,
        vegetationIndex:index_val
    }
    mapped_Data.push(_series)

  } 
  return mapped_Data
}
else{
    return mapped_Data
}
}

export function Crop_Performance(year, cropid, score, vegetaton_index) {
    let crop_filter = [cropid]
    let year_filter = [year]
    let growth_period_key  = []
    let filtered_crop_score = score.filter(function(itm){
    return crop_filter.indexOf(itm.crop_id) > -1;
    });
    let growth_period = filtered_crop_score[0].growthParameter.growth_period_month
    let _next_year
    if (growth_period[1] > 12)
        {_next_year = year_filter[0]+1}
    else{_next_year = year_filter[0]}
        for (let i = growth_period[0]-1; i < growth_period[1]; i++){
            let periodkey 
            if (i+1 > 12){
                periodkey = [_next_year, i-12+1]
                }
            else{
                periodkey = [year, i+1]
            }
            growth_period_key.push(periodkey.join("_"))
    }
    let filtereded_growth_index = vegetaton_index.filter(function(itm){
        let _filterconst = [itm.year,itm.month].join("_")
        return growth_period_key.indexOf(_filterconst) > -1;
    })
    let filtered_Index_array = []
    filtereded_growth_index.forEach(element => {
        filtered_Index_array.push(element.vegetationIndex)
    });
    
    let max_index_val = Math.max.apply(null, filtered_Index_array) 
    let score_array = filtered_crop_score[0].growthParameter.perf_score
    let crop_performance_score 
    for(let i = 0; i < score_array.length; i++){
        if (max_index_val < score_array[score_array.length - i]){
            crop_performance_score = i-1
            break
        }
        else {
            crop_performance_score = score_array.length
        }
    }
    return crop_performance_score
}


export function Crop_Moisture_Performance(year, cropid, score, moisture_index) {
    let crop_filter = [cropid]
    let year_filter = [year]
    let growth_period_key  = []
    let filtered_crop_score = score.filter(function(itm){
    return crop_filter.indexOf(itm.crop_id) > -1;
    });
    let growth_period = filtered_crop_score[0].growthParameter.growth_period_month
    let _next_year
    if (growth_period[1] > 12)
        {_next_year = year_filter[0]+1}
    else{_next_year = year_filter[0]}
        for (let i = growth_period[0]-1; i < growth_period[1]; i++){
            let periodkey 
            if (i+1 > 12){
                periodkey = [_next_year, i-12+1]
                }
            else{
                periodkey = [year, i+1]
            }
            growth_period_key.push(periodkey.join("_"))
    }
    let filtereded_growth_index = moisture_index.filter(function(itm){
        let _filterconst = [itm.year,itm.month].join("_")
        return growth_period_key.indexOf(_filterconst) > -1;
    })
    let filtered_Index_array = []
    filtereded_growth_index.forEach(element => {
        filtered_Index_array.push(element.moistureIndex)
    });
    let max_index_val = Math.max.apply(null, filtered_Index_array) 
    let score_array = filtered_crop_score[0].growthParameter.risk_score
    let crop_moisture_score 
    for(let i = 0; i < score_array.length; i++){
        if (max_index_val < score_array[score_array.length - i]){
            crop_moisture_score = i-1
            break
        }
        else {
            crop_moisture_score = score_array.length
        }
    }
    return crop_moisture_score
}



export function CropPerfMoistureTable(crop_table,score,moisture_index){
    let cropperftable = []
    let year
    let cropid
    let season
    let moisturescore
    let survey_no
    let area 
    let cropname
    let season_weight
    for ( let i =0; i < crop_table.length; i++){
        year = crop_table[i].year
        cropid = crop_table[i].crop_id
        // cropid = crop_table[i].crop_id
        season = crop_table[i].crop_season
        season_weight = crop_table[i].season_weight
        survey_no = crop_table[i].survey_no
        area = crop_table[i].survey_area
        cropname = crop_table[i].cropname
        moisturescore= Crop_Moisture_Performance(year, cropid, score, moisture_index)
        let _var = {
            year: year,
            season:season,
            survey_no:survey_no,
            area: area,
            cropid: cropid,
            cropname: cropname,
            moisturescore:moisturescore,
            season_weight: season_weight
        }
        cropperftable.push(_var)
    }
    return cropperftable
  }

export function sumMoisture(moisturetable){
    let sum = 0
    let count = 0
    let weighted_score
    for (let i = 0; i < moisturetable.length; i++) {
        if(moisturetable[i].moisturescore !==undefined && moisturetable[i].moisturescore!==null)
        {sum += moisturetable[i].moisturescore*moisturetable[i].season_weight
        count += moisturetable[i].season_weight}
    }
    weighted_score = sum/count
}

export function CropPerfTable(crop_table,score,vegetaton_index){
    let cropperftable = []
    let year
    let cropid
    let season
    let perfscore
    let survey_no
    let area 
    let cropname
    let season_weight
    for ( let i =0; i < crop_table.length; i++){
        year = crop_table[i].year
        cropid = crop_table[i].crop_id
        // cropid = crop_table[i].crop_id
        season = crop_table[i].crop_season
        season_weight = crop_table[i].season_weight
        survey_no = crop_table[i].survey_no
        area = crop_table[i].survey_area
        cropname = crop_table[i].cropname
        perfscore= Crop_Performance(year,cropid, score, vegetaton_index)
        let _var = {
            year: year,
            season:season,
            survey_no:survey_no,
            area: area,
            cropid: cropid,
            cropname: cropname,
            perfscore:perfscore,
            season_weight: season_weight
        }
        cropperftable.push(_var)
    }
    return cropperftable
  }

  export function sumPerformance(perftable){
    let sum = 0
    let count = 0
    let weighted_score
    for (let i = 0; i < perftable.length; i++){
        if( perftable[i].perfscore !==undefined && perftable[i].perfscore!=null
            )
        {sum += perftable[i].perfscore*perftable[i].season_weight
         count+=perftable[i].season_weight
        }
        weighted_score = sum/count
    }
    return weighted_score
    
}

  export function SeasonScoreAggregate(scoremat){
    let seasonal_score = []
    for (let i = 0;i < season.length; i ++ ){
        let _scoremat=[]
        scoremat.forEach((item) => {
            // console.log(item.season)
            if(item.season ===season[i].toLowerCase()){
                if(item.perfscore !==undefined || item.perfscore !== null)
                {_scoremat.push(item.perfscore)}
            }
        })
        let sum = 0
        let avg =0
        for ( let i = 0; i < _scoremat.length; i ++){
            sum += _scoremat[i]
        }
        avg = (sum/_scoremat.length)
        seasonal_score.push({season:season[i], yield_score:avg})
    }
   return seasonal_score
}


export function SeasonMoistureAggregate(scoremat){
    let seasonal_score = []
    for (let i = 0;i < season.length; i ++ ){
        let _scoremat=[]
        scoremat.forEach((item) => {
            if(item.season ===season[i].toLowerCase()){
                if(item.moisturescore !==undefined || item.moisturescore !== null)
                {_scoremat.push(item.moisturescore)}
            }
        })
        let sum = 0
        let avg =0
        for ( let i = 0; i < _scoremat.length; i ++){
            sum += _scoremat[i]
        }
        avg = (sum/_scoremat.length)
        seasonal_score.push({season:season[i], moisture_score:avg})   
    }
   return seasonal_score
}


















































 
 
        